export default "__VITE_ASSET__DfjAz4hh__"